<template>
  <div class="max-w-5xl mx-auto p-5 text-xs text-gray-700">
    <p>Italia non profit pubblica nella pagina le raccolte fondi:</p>

    <ul class="list-disc list-inside">
      <li>di enti non profit che si sono iscritti alla sua piattaforma e dei quali è stata controllata la corrispondenza tra i
        dati dell’ente e quelli prodotti nella documentazione (statuti);</li>
      <li>di enti non profit iscritti alla piattaforma e i cui documenti sono ancora in via di approvazione e gradualmente
      verranno verificati; per questi, si è ritenuto importante procedere comunque alla pubblicazione delle campagne,
      mostrando un segno distintivo (*) e codesto disclaimer nel quale si palesa che l’ente è iscritto alla piattaforma e
      che i suoi documenti istituzionali non sono ancora stati controllati. Italia non profit non intermedia le campagne
      pubblicate dalle organizzazioni e offre il servizio di pubblicazione delle stesse a titolo totalmente gratuito.
      Italia non profit non può in alcun caso essere ritenuta responsabile in merito ai successivi esiti, destinazioni ed
      impieghi delle raccolte fondi pubblicate. I dati e le informazioni sulle campagne di raccolta fondi sono pubblicati
      direttamente dagli enti organizzatori e pertanto eventuali errori, inesattezze, mancanze ed omissioni rinvenibili
        nei contenuti pubblicati sono da addebitarsi agli enti organizzatori.</li>
    </ul>

    <p>
      Per segnalazioni: <a href="mailto:natale@italianonprofit.it">natale@italianonprofit.it</a>
    </p>
  </div>
</template>